import * as Html from "../util/Html.ts";

Html.registerWidget('widget/select-with-value',{
  initDom(element: HTMLElement){
    const select = element as HTMLSelectElement;
    const selectedValue = select.getAttribute("data-fw-select-value");
    if(!selectedValue) return;

    const option = select.querySelector(`option[value='${selectedValue}']`) as HTMLOptionElement;
    if(option) {
      option.selected = true;
    }
  }
})